// Kusanagi の slugify()（NFKC 正規化 → 小文字化 → [a-z0-9] 以外をハイフンに畳む → 64 文字上限）を
// クライアント側で再現した表示用プレビュー。実際の slug は Kusanagi がサーバ側で導出し、
// 重複時は連番サフィックスが付くため、あくまで「見込み」の表示に使う。
export const deriveSlugPreview = (name) => {
    return name
        .normalize('NFKC')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 64)
        .replace(/-+$/g, '');
};
